import { SocialAccountType } from '@anytag/graphql';
import { FormAction } from '@anytag/shared-types';
import { BaseModal, Form } from '@anytag/shared-atoms';
import { Template } from './Template';
import { defaultTalentInfluencerFormValues } from './utils';
import { TalentInfluencerFormValues, TalentInfluencerFormSchema } from './schema-types';
import { useConnectedTalentAccountsFromState } from './useConnectedTalentAccountsFromState';
import { SelectAccountModalContent, SelectableFanpagesModalContent } from './SelectedModalContent';

export type TalentInfluencerFormProps = FormAction<TalentInfluencerFormValues>;

export const TalentInfluencerForm = ({
  onSubmit,
  defaultValues = defaultTalentInfluencerFormValues
}: TalentInfluencerFormProps) => {
  const {
    t,
    modalTitle,
    onCloseFb,
    onCloseIgOrYt,
    hasIgModalOpened,
    selectDraftIgAccount,
    selectDraftFacebookPage,
    selectDraftYtChannel,
    setModalStep,
    addSelectedDraftFbPageAndIgAccounts,
    allConnectableIgAccounts,
    addSelectedDraftIgAccount,
    addSelectedDraftYtChannel,
    state
  } = useConnectedTalentAccountsFromState(defaultValues as TalentInfluencerFormValues);

  return (
    <>
      {state.connectType === SocialAccountType.FACEBOOK ? (
        <BaseModal
          onClose={onCloseFb}
          open={Boolean(state.isModalOpen && state.connectableFbFanpages?.length)}
          title={t(state.step === 1 ? 'Choose Facebook pages' : 'Choose Instagram Account')}
          footer={{
            cancelButton: { onClick: onCloseFb, title: t(state.step === 1 ? 'Cancel' : 'Previous') },
            submitButton:
              state.step === 1 && allConnectableIgAccounts?.length
                ? {
                    title: t('Next'),
                    onClick: () => setModalStep(2)
                  }
                : {
                    title: t('Save'),
                    onClick: () => addSelectedDraftFbPageAndIgAccounts()
                  }
          }}
        >
          <SelectableFanpagesModalContent
            allConnectableIgAccounts={allConnectableIgAccounts}
            selectDraftIgAccount={selectDraftIgAccount}
            selectDraftFacebookPage={selectDraftFacebookPage}
            state={state}
          />
        </BaseModal>
      ) : (
        <BaseModal
          open={Boolean(
            state.isModalOpen && (state.connectableIgAccounts?.length || state.connectableYtChannels?.length)
          )}
          onClose={onCloseIgOrYt}
          title={t(modalTitle)}
          footer={{
            cancelButton: { onClick: onCloseIgOrYt },
            submitButton: {
              title: t('Button.OK'),
              onClick: hasIgModalOpened ? addSelectedDraftIgAccount : addSelectedDraftYtChannel
            }
          }}
        >
          <SelectAccountModalContent
            state={state}
            selectDraftIgAccount={selectDraftIgAccount}
            selectDraftYtChannel={selectDraftYtChannel}
          />
        </BaseModal>
      )}
      <Form.Provider<TalentInfluencerFormValues>
        onSubmit={onSubmit}
        className="bg-transparent"
        values={state.savedFormValues}
        zodSchema={TalentInfluencerFormSchema}
      >
        <Template />
      </Form.Provider>
    </>
  );
};

export * from './schema-types';
export {
  getTalentInfluencerFormValues,
  defaultTalentInfluencerFormValues,
  getCreateUpdateTalentInfluencerInput
} from './utils';
